class QueryParams {
	queryParams: URLSearchParams;
	paramsObject: {
		key?: string;
		name?: string;
	};
	constructor() {
		this.queryParams = new URLSearchParams( window.location.search );
		this.paramsObject = {};

		this.queryParams.forEach( ( value, key ) => {
			this.paramsObject[ key ] = value;
		} );
	}
	getUrlParameter = ( queryName: string ) => {
		const regex = new RegExp( '[\\?&]' + queryName + '=([^&#]*)' );
		const results = regex.exec( location.search );
		return results === null
			? ''
			: decodeURIComponent( results[ 1 ].replace( /\+/g, ' ' ) )
					?.split( ',' )
					?.map( function ( id ) {
						const isNum = /^\d+$/.test( id );
						if ( isNum ) {
							return parseInt( id, 10 );
						}
						return id;
					} );
	};
	pushQueryParamsToUrl = ( queryName: string, queryValue: { key: string; name: string | number }[] ) => {
		if ( queryValue?.length > 0 ) {
			this.paramsObject = { ...this.paramsObject, [ queryName ]: queryValue };
		} else {
			delete this.paramsObject[ queryName ];
		}

		const newQueryParams = new URLSearchParams( this.paramsObject );
		const newQueryParamsString = newQueryParams.toString();
		if ( ! newQueryParamsString ) {
			window.history.replaceState( {}, '', window.location.pathname );
		}
		if ( newQueryParamsString ) {
			window.history.replaceState( {}, '', `?${ newQueryParamsString }` );
		}
	};
	getAllParamKeys = () => {
		const keys = [];
		for ( const key of new URLSearchParams( window.location.search ).keys() ) {
			keys.push( key );
		}
		return keys;
	};
}

export default QueryParams;
